// 홈스쿨링 - 본사 - 지사별 통계
import React, { useState, useEffect, useCallback, forwardRef, useImperativeHandle } from "react";

import axios from "@app/lib/axios";

import ReactEcharts from "echarts-for-react";
import CommonHorizontalBarChart from "@app/components/CommonHorizontalBarChart";

import FlyEngConstants from "@app/config/FlyEngConstants";
import flyengStyle from "../../components/style";

import { NurseryClassChild } from "../../components/NurseryClassChild";

const NurseryContentNursery = forwardRef(({ statPeriod, libCategories, branchId, branchName, nurseryId, nurseryName, updateViewSubOption }, ref) => {
    const [loadingData, setLoadingData] = useState(false);
    const [stat, setStat] = useState(false);
    const [statAge, setStatAge] = useState(false);
    const [statOs, setStatOs] = useState(false);
    const [statContent, setStatContent] = useState(false);
    const [statContentSum, setStatContentSum] = useState(false);
    const [statClass, setStatClass] = useState(false);
    const [statChild, setStatChild] = useState(false);
    const [childStatDate, setChildStatDate] = useState(false);
    let colorContent = false;
    let colorContentSum = false;

    useImperativeHandle(ref, () => ({
        getExcelData(callback) {
            const excelData = {
                fileName: "플라잉홈_원통계",
                sheets: [
                    {
                        name: "접속",
                        title: `${nurseryName} - 접속 통계`,
                        columnTitle: ["연령", "안드로이드", "IOS", "웹"],
                        data: stat ? stat.map((s) => [s.name, s.osAndroid, s.osIos, s.osWeb]) : [],
                    },
                    {
                        name: "연령(순)",
                        title: `${nurseryName} - 연령별 콘텐츠 순 사용 통계`,
                        columnTitle: ["연령", "실행 수"],
                        data: statAge ? statAge.map((s) => [s.name, s.playCount]) : [],
                    },
                    {
                        name: "연령(누적)",
                        title: `${nurseryName} - 연령별 콘텐츠 누적 사용 통계`,
                        columnTitle: ["연령", "실행 수"],
                        data: statAge ? statAge.map((s) => [s.name, s.playCountSum]) : [],
                    },
                    {
                        name: "회원가입",
                        title: `${nurseryName} - 학부모 가입 통계 (원아 자료 기준일 - ${childStatDate})`,
                        columnTitle: ["반", "계약 원아 수", "회원 가입 수"],
                        data: statClass ? statClass.map((s) => [s.name, s.contractChild, s.childJoin]) : [],
                    },
                ],
            };
            callback(null, excelData);
        },
    }));
    const initData = () => {
        setStat(false);
        setStatAge(false);
        setStatOs(false);
        setStatContent(false);
        setStatContentSum(false);
        setStatClass(false);
        setStatChild(false);
        setChildStatDate(false);
    };
    const getStat = useCallback(() => {
        setLoadingData(true);
        initData();
        axios({
            method: "POST",
            url: `/api/flyeng_stat_2022/home/branch/${branchId}/nursery/${nurseryId}/content`,
            data: {
                start: statPeriod.startDate,
                end: statPeriod.endDate,
                periodType: statPeriod.type,
            },
        })
            .then((result) => {
                if (result.data.code === 200) {
                    const stat = result.data.data;
                    const statChild = { contractChild: 0, childJoin: 0 };
                    var statAge = [
                            { id: "0", name: "만2세", playCount: 0, playCountSum: 0 },
                            { id: "1", name: "만3세", playCount: 0, playCountSum: 0 },
                            { id: "2", name: "만4세", playCount: 0, playCountSum: 0 },
                            { id: "3", name: "만5세", playCount: 0, playCountSum: 0 },
                        ],
                        statOs = [
                            { id: "app", name: "앱", value: 0 },
                            { id: "web", name: "웹", value: 0 },
                        ],
                        statContent = libCategories.map((lc) => {
                            return { id: `playCountCat_${lc.id}`, name: lc.name, value: 0 };
                        }),
                        statContentSum = libCategories.map((lc) => {
                            return { id: `playCountSumCat_${lc.id}`, name: lc.name, value: 0 };
                        });
                    stat.forEach((s) => {
                        const level = FlyEngConstants.LEVEL.find((l) => l.age === s.age);
                        s.name = `만${s.age + 2}세`;
                        s.ageName = level ? `레벨${level.name}` : "-";
                        if (libCategories) {
                            libCategories.forEach((lc) => {
                                const playCountField = `playCountCat_${lc.id}`;
                                const playCountSumField = `playCountSumCat_${lc.id}`;
                                statAge[s.age].playCount += s[playCountField];
                                statAge[s.age].playCountSum += s[playCountSumField];
                                statAge[playCountField] = s[playCountField] || 0;
                                statAge[playCountSumField] = s[playCountSumField] || 0;
                            });
                        }
                    });
                    statOs[0].value = stat.reduce((ac, current) => ac + (current.osAndroid || 0) + (current.osIos || 0), 0);
                    statOs[1].value = stat.reduce((ac, current) => ac + (current.osWeb || 0), 0);
                    statContent.forEach((s) => {
                        s.value = stat.reduce((ac, current) => ac + (current[s.id] || 0), 0);
                    });
                    statContentSum.forEach((s) => {
                        s.value = stat.reduce((ac, current) => ac + (current[s.id] || 0), 0);
                    });
                    if (result.data.classStat && result.data.classStat.length > 0) {
                        result.data.classStat.forEach((s) => {
                            statChild.contractChild += s.contractChild || 0;
                            statChild.childJoin += s.childJoin || 0;
                        });
                    }

                    setStat(stat);
                    setStatAge(statAge);
                    setStatOs(statOs);
                    setStatContent(statContent);
                    setStatContentSum(statContentSum);
                    setStatClass(result.data.classStat);
                    setStatChild(statChild);
                    setChildStatDate(result.data.childStatDate);
                } else {
                    alert(result.data && result.data.msg ? result.data.msg : "통계 정보를 가져오는데 실패하였습니다.\n지속 발생시 관리자에게 문의해주세요.");
                }
                setLoadingData(false);
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                setLoadingData(false);
            });
    }, [statPeriod]);
    useEffect(() => {
        getStat();
        return () => {};
    }, [getStat]);

    const optionOs = {
        tooltip: {
            trigger: "item",
            formatter: (param) => {
                return param.data ? param.data.name + " : " + param.data.value.toLocaleString() + " (" + param.percent + "%)" : "";
            },
        },
        series: {
            type: "pie",
            center: ["50%", "55%"],
            data: statOs,
            radius: "80%",
            animation: false,
            startAngle: 225,
            label: {
                show: true,
                formatter: function (params) {
                    return `${params.name}\n${params.value.toLocaleString()}, ${params.percent}%`;
                },
                fontSize: 15,
                color: "#000",
            },
        },
        color: ["#60d7c5", "#b9ed4a"],
    };
    const onContentEvent = {
        finished: (e, charts) => {
            if (!colorContent) {
                colorContent = charts._model.option.color;
            } else {
                if (colorContent.length != charts._model.option.color.length) {
                    colorContent = charts._model.option.color;
                } else {
                    let changed = false;
                    for (let i = 0; i < colorContent.length; i++) {
                        if (colorContent[i] != charts._model.option.color[i]) {
                            changed = true;
                            break;
                        }
                    }
                    if (changed) {
                        colorContent = charts._model.option.color;
                    }
                }
            }
        },
    };
    const onContentSumEvent = {
        finished: (e, charts) => {
            if (!colorContentSum) {
                colorContentSum = charts._model.option.color;
            } else {
                if (colorContentSum.length != charts._model.option.color.length) {
                    colorContentSum = charts._model.option.color;
                } else {
                    let changed = false;
                    for (let i = 0; i < colorContentSum.length; i++) {
                        if (colorContentSum[i] != charts._model.option.color[i]) {
                            changed = true;
                            break;
                        }
                    }
                    if (changed) {
                        colorContentSum = charts._model.option.color;
                    }
                }
            }
        },
    };
    const optionContent = {
        tooltip: {
            trigger: "item",
            backgroundColor: "rgba(50,50,50,0.9)",
            formatter: (params, charts, test) => {
                const total = statContent ? statContent.reduce((ac, current) => ac + current.value, 0) : 0;
                const tip = statContent
                    ? statContent
                          .map(
                              (s, idx) =>
                                  `<div class='row' style='margin-left: 3px;margin-right: 3px;width: 210px${
                                      s.id == params.data.id ? ";border-bottom: 1px solid #dddddd;margin-bottom: 3px;height: 18px" : ""
                                  }'><div class='d-flex justify-content-end mr-2' style='width: 90px'>${
                                    colorContent && colorContent.length > idx
                                          ? `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${colorContent[idx]};"></span>`
                                          : ""
                                  }${s.name} :</div><div>${s.value.toLocaleString()}, ${((s.value / total) * 100).toFixed(1)}%</div></div>`
                          )
                          .join("")
                    : "";
                return (
                    tip +
                    `<div style="height: 1px;border-bottom: 1px solid #aaa"></div><div class='row font-weight-bold' style='width: 210px'><div class='d-flex justify-content-end mr-2' style='width: 108px'>합계 :</div><div>${total.toLocaleString()}</div></div>`
                );
            },
        },
        series: [
            {
                type: "pie",
                data: statContent,
                radius: ["0%", "90%"],
                animation: true,
                labelLine: {
                    show: false,
                },
                label: {
                    show: false,
                    position: "center",
                },
            },
        ],
        color: flyengStyle.seriesHomeColor.normal,
    };
    const optionContentSum = {
        tooltip: {
            trigger: "item",
            backgroundColor: "rgba(50,50,50,0.9)",
            formatter: (params, chart, test) => {
                const total = statContentSum ? statContentSum.reduce((ac, current) => ac + current.value, 0) : 0;
                const tip = statContentSum
                    ? statContentSum
                          .map(
                              (s, idx) =>
                                  `<div class='row' style='margin-left: 3px;margin-right: 3px;width: 210px${
                                      s.id == params.data.id ? ";border-bottom: 1px solid #dddddd;margin-bottom: 3px;height: 18px" : ""
                                  }'><div class='d-flex justify-content-end mr-2' style='width: 90px'>${
                                    colorContentSum && colorContentSum.length > idx
                                          ? `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${colorContentSum[idx]};"></span>`
                                          : ""
                                  }${s.name} :</div><div>${s.value.toLocaleString()}, ${((s.value / total) * 100).toFixed(1)}%</div></div>`
                          )
                          .join("")
                    : "";
                return (
                    tip +
                    `<div style="height: 1px;border-bottom: 1px solid #aaa"></div><div class='row font-weight-bold' style='width: 210px'><div class='d-flex justify-content-end mr-2' style='width: 108px'>합계 :</div><div>${total.toLocaleString()}</div></div>`
                );
            },
        },
        series: [
            {
                type: "pie",
                data: statContentSum,
                radius: ["0%", "90%"],
                animation: true,
                labelLine: {
                    show: false,
                },
                label: {
                    show: false,
                    position: "center",
                },
            },
        ],
        color: flyengStyle.seriesHomeColor.normal,
    };
    const chartOptionContent = {
        grid: {
            top: "12%",
            left: "10%",
            right: "5%",
            bottom: "10%",
        },
        xAxis: { field: "name" },
        yAxis: {
            name: "건",
            series: flyengStyle.seriesHomePlayChart2022,
        },
        stacks: [{ stack: "base", showSum: false, showSumTooltip: true, showPercent: true }],
        showLegend: false,
        sort: false,
    };
    const chartOptionContentSum = {
        grid: {
            top: "12%",
            left: "10%",
            right: "5%",
            bottom: "10%",
        },
        xAxis: { field: "name" },
        yAxis: {
            name: "건",
            series: flyengStyle.seriesHomePlaySumChart2022,
        },
        stacks: [{ stack: "base", showSum: false, showSumTooltip: true, showPercent: true }],
        showLegend: false,
        sort: false,
        grid: {
            top: "12%",
            left: "10%",
            right: "5%",
            bottom: "10%",
        },
    };
    const childChartOption = {
        xAxis: {
            type: "category",
            data: ["가입 현황"],
        },
        yAxis: {
            name: "명",
            type: "value",
        },
        grid: {
            top: "20%",
            left: "10%",
            bottom: "10%",
        },
        legend: {
            x: "right",
        },
        tooltip: {
            show: true,
            trigger: "axis",
            axisPointer: {
                type: "cross",
                crossStyle: {
                    color: "#999",
                },
            },
        },
        series: [
            {
                type: "bar",
                data: [statChild ? statChild.contractChild : 0],
                ...flyengStyle.seriesHomeChildChart[0],
            },
            {
                type: "bar",
                data: [statChild ? statChild.childJoin : 0],
                ...flyengStyle.seriesHomeChildChart[1],
            },
        ],
    };
    return (
        <div className="stat-branch-content">
            <div className="row mb-3">
                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                    <div className="card">
                        <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                            <h5 className="card-header-title">접속 경로</h5>
                        </div>
                        <div className="card-body" style={{ height: "auto" }}>
                            <ReactEcharts theme="macarons" option={optionOs} style={{ height: `220px` }} />
                        </div>
                    </div>
                </div>
                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                    <div className="card">
                        <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                            <h5 className="card-header-title">콘텐츠 사용 현황</h5>
                        </div>
                        <div className="card-body" style={{ height: "auto" }}>
                            <div className="row">
                                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                                    <span className="d-flex justify-content-end">- 순 사용량 -</span>
                                    <ReactEcharts id="charts-axxx" theme="macarons" option={optionContent} style={{ height: `200px` }} onEvents={onContentEvent} />
                                </div>
                                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                                    <span className="d-flex justify-content-end">- 누적 사용량 -</span>
                                    <ReactEcharts theme="macarons" option={optionContentSum} style={{ height: `200px` }} onEvents={onContentSumEvent} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                    <div className="card">
                        <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                            <h5 className="card-header-title">콘텐츠 순 실행 수</h5>
                        </div>
                        <div className="card-body" style={{ height: "300px" }}>
                            <CommonHorizontalBarChart chartData={statAge} chartOption={chartOptionContent} />
                        </div>
                    </div>
                </div>
                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                    <div className="card">
                        <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                            <h5 className="card-header-title">콘텐츠 누적 실행 수</h5>
                        </div>
                        <div className="card-body" style={{ height: "300px" }}>
                            <CommonHorizontalBarChart chartData={statAge} chartOption={chartOptionContentSum} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <div className="card">
                        <div className="card-header">학부모 가입 현황</div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                                    <div className="">
                                        <NurseryClassChild height={200} statList={statClass} childStatDate={childStatDate} />
                                    </div>
                                </div>
                                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                                    <div className="">
                                        <ReactEcharts theme="macarons" style={{ height: "350px" }} option={childChartOption} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
});

export default NurseryContentNursery;
